import { Button } from "@newsela/angelou";

const getButtonProps = (flavor = "tertiary") => ({
  size: Button.sizes.md,
  flavor: Button.flavors[flavor],
});

export default getButtonProps;
